import React from 'react';
import { PublicLayout } from '../../components/PublicLayout';
import { PublicPageSeo } from '../../components/PublicPageSeo';
import { RelatedLinks } from '../../components/RelatedLinks';
import { getContent } from '../../content/i18n';
import { useLocale, useLocalizedPath } from '../../hooks/useLocale';

export const FeaturesPage: React.FC = () => {
  const locale = useLocale();
  const localizedPath = useLocalizedPath();
  const content = getContent(locale);
  const { features } = content;
  const homePath = locale === 'en' ? '/en' : '/';
  const pagePath = locale === 'en' ? '/en/features' : '/features';

  return (
    <>
      <PublicPageSeo
        breadcrumbs={[
          { name: content.common.home, path: homePath },
          { name: features.title, path: pagePath },
        ]}
      />
      <PublicLayout
        breadcrumbs={[
          { label: content.common.home, href: localizedPath('/') },
          { label: features.title },
        ]}
      >
        <section className="py-12">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">{features.title}</h1>
          <p className="text-lg text-gray-600 dark:text-gray-300 mb-12 max-w-3xl">{features.subtitle}</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            {features.sections.map((section) => (
              <div
                key={section.title}
                className="p-6 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900"
              >
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">{section.title}</h2>
                <p className="text-gray-600 dark:text-gray-300 leading-relaxed">{section.description}</p>
              </div>
            ))}
          </div>

          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
            {locale === 'zh' ? '适用场景' : 'Use Cases'}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.scenarios.map((scenario) => (
              <div key={scenario.title} className="p-5 bg-gray-50 dark:bg-gray-800 rounded-lg">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2">{scenario.title}</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300">{scenario.description}</p>
              </div>
            ))}
          </div>
        </section>

        <RelatedLinks
          links={[
            { label: locale === 'zh' ? '套餐价格' : 'Pricing', href: '/pricing' },
            { label: locale === 'zh' ? '客户端下载' : 'Download', href: '/download' },
            { label: locale === 'zh' ? '帮助中心' : 'Help', href: '/help' },
          ]}
        />
      </PublicLayout>
    </>
  );
};
